import type { BusinessAction, BusinessStatus } from "./types";

/**
 * Which actions are legal from which status — the same table the backend
 * enforces in domain/businesses/lifecycle.ts.
 *
 * Offering all ten regardless of status is what produced "Cannot activate
 * Business from status under_review": a reviewer picked the obvious-sounding
 * action, confirmed, and was told no by the server. An action that cannot
 * succeed should not be selectable.
 *
 * `submit` is absent on purpose — it belongs to the applicant, and Play calls
 * it. `mark_verified` is absent because Approve does it (see BusinessActionDialog).
 */
export const ALLOWED_FROM: Partial<Record<BusinessAction, readonly BusinessStatus[]>> = {
  start_review: ["applied", "more_information_required"],
  request_more_information: ["under_review", "applied"],
  reject: ["under_review", "applied", "more_information_required"],
  activate: ["verified", "under_review"],
  restrict: ["active", "verified"],
  suspend: ["active", "restricted", "verified"],
  restore: ["restricted", "suspended"],
  close: [
    "draft",
    "applied",
    "under_review",
    "more_information_required",
    "verified",
    "active",
    "restricted",
    "suspended",
    "rejected",
  ],
};

/** Whether `action` can run from `status` — the table above, for other screens. */
export function canApplyAction(action: BusinessAction, status: BusinessStatus): boolean {
  return ALLOWED_FROM[action]?.includes(status) ?? false;
}
